import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UniChartComponent } from "@universal-ui";

import { BalancesGraphicComponent } from "./balances-graphic.component";

@NgModule({
  declarations: [BalancesGraphicComponent],
  imports: [CommonModule, UniChartComponent],
  exports: [BalancesGraphicComponent],
})
export class BalancesGraphicModule {}
